<template>
    <div class="down-box">
      <img class="left-img" src="https://p3.ssl.qhimg.com/t110b9a930125907b0e38fffc6c.png" alt="" />
      <img class="right-btn" src="https://p1.ssl.qhimg.com/t110b9a9301b9d21bb578e01adf.png" alt="" @click="downloadApp('https://work.n.cn/?src=isc')"  />
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'

  const downloadApp = (url) => {
    window.open(url)
  }
  </script>
  
  <style lang="scss" scoped>
  .down-box {
    position: fixed;
    width: 100%;
    height: 80px;
    left: 0;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    z-index: 99;
    background: linear-gradient(281deg, #67baff 0%, #8ec8ff 33%, #d6f4ff 100%);
    .left-img {
      width: 42%;
    }
    .right-btn {
      width: 42%;
    }
  }
  </style>
  